import { Gql } from '@fiverr-private/dynamic_matching';

export interface GeneratedContent {
    title: string;
    content: string;
    included: boolean;
}

export interface Content {
    generatedContent?: GeneratedContent[];
}

export interface IdealCandidatePreferences {
    skillsAndExperience?: string;
    languages?: FreelancerLanguagePreference[];
    countries?: FreelancerCountryCode[];
    regions?: string[];
    timezone?: FreelancerTimezone;
    freelancerType?: FreelancerType;
}

export interface FreelancerLanguagePreference {
    languageCode: string;
    minProficiency: Gql.LanguageProficiencyLevel;
}

export const FreelancerLanguageMinProficiency = Gql.LanguageProficiencyLevel;
export type FreelancerLanguageMinProficiencyType = FreelancerLanguagePreference['minProficiency'];

export type FreelancerCountryCode = Gql.DmBriefCountryCode;
export interface CountriesAndRegions {
    countries: FreelancerCountryCode[];
    regions: string[];
}

export type FreelancerTimezone = Gql.DmBriefTimezone;
export type FreelancerType = Gql.DmBriefFreelancerType;
export type FreelancerTypeMinLevel = Gql.DmBriefSellerLevel;

export type ChosenCategory = 'location' | 'timezone';

export interface ListOption {
    value: string;
    label: string;
}
